<template>
  <div class="button" id="checkoutButtonSilver">Upgrade</div>
</template>

<script>
import axios from 'axios'
// import { mapActions } from 'vuex'
import alert from '@/lib/alert'
const stripe = window.Stripe('pk_live_51HNzjTIN9DcikqnzLDMKT9cb3tmwAzEkuUQse3uGjwJ9GVlmUb3GKz9UpK8kLezYM6Hiz6MgGROrGmflETEIjvh100kplwReyZ');
// const stripe = window.Stripe('pk_test_51HJ1NfJP67VVffGo4AsyVxmBk36BjXrsWUSjUNlO2XSwIkwNQF6OGVasLwm46DeEfMESyZamhvsHGxmvqmsPSe9x00qVv9Fwng');


export default {
  name: 'UpgradeButtonSilver',
  methods: {
    // ...mapActions('alerts', ['setError', 'setWarning']),
    createCheckoutSession() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}createCheckoutSession`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        data: {
          plan: 'silver'
        }
      }).then(result => {
        const checkoutId = result.data.id;
        stripe.redirectToCheckout({
          sessionId: checkoutId
        }).then(result => {
          console.log(result);
        });
      }).catch(err => {
        console.log(err);
        // this.setError(err);
        alert.showError(err);
      })
    }
  },
  mounted() {
    const checkoutButton = document.querySelector('#checkoutButtonSilver');
    checkoutButton.addEventListener('click', this.createCheckoutSession);
  }
}
</script>

<style lang="scss" scoped>
.button {
  width: 8rem;
  height: 2.3rem;
  background-color: #a3a2a2;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.1rem;
  transition: 0.3s;

  @media (max-width: 700px) {
    width: 6rem;
  }

  @media (max-width: 600px) {
    width: 10rem;
  }

  &:hover {
    cursor: pointer;
    background-color: #8d8c8c;
  }
}
</style>